<template>
  <footer class="bg-theme-bg-subtle dark:bg-theme-surface border-t border-theme-border dark:border-theme-border">
    <div class="mx-auto w-full max-w-7xl px-6 py-6">
      <div class="flex flex-col md:flex-row items-center justify-between gap-4">
        <!-- Logo + copyright -->
        <div class="flex items-center gap-6">
          <router-link to="/" class="inline-flex items-center">
            <span class="bg-clip-text text-transparent bg-gradient-to-br from-theme-palette-emerald to-theme-palette-emerald font-azonix text-xl">
              PROFITEIA
            </span>
          </router-link>
          <span class="text-sm text-theme-text-secondary">© {{ year }} Profiteia</span>
        </div>

        <!-- Footer links -->
        <div>
            <nav
              aria-label="Footer links"
              class="flex flex-wrap items-center justify-center md:justify-end gap-2 text-sm"
            >
              <router-link
                to="/subscriptions"
                class="text-theme-text-secondary hover:text-theme-palette-emerald dark:hover:text-theme-palette-emerald transition-colors px-3 py-1"
              >
                {{ t('footer.subscriptions') }}
              </router-link>

              <router-link
                to="/about"
                class="text-theme-text-secondary hover:text-theme-palette-emerald dark:hover:text-theme-palette-emerald transition-colors px-3 py-1"
              >
                {{ t('footer.about_us') }}
              </router-link>

              <router-link
                to="/contact"
                class="text-theme-text-secondary hover:text-theme-palette-emerald dark:hover:text-theme-palette-emerald transition-colors px-3 py-1"
              >
                {{ t('footer.contact') }}
              </router-link>

              <button
                type="button"
                class="text-theme-text-secondary hover:text-theme-palette-emerald dark:hover:text-theme-palette-emerald transition-colors px-3 py-1"
                @click="openNewsletter"
              >
                {{ t('footer.newsletter') }}
              </button>
            </nav>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDisplayStore } from '@/stores/useDisplayStore';
const { t } = useI18n();

const displayStore = useDisplayStore()
const year = computed(() => new Date().getFullYear())
const openNewsletter = () => displayStore.newsletterModalToggle(true)
</script>

<style scoped>
  footer {
    z-index: 35;
  }
</style>
